<template>
    <div class="all-section-area">
        <MainHeader />
        <main class="main-content-wrap">
            <PageTitle mainTitle="Followers" pageTitle="Followers" />
            <FollowersContent />
            <div class="flex-grow-1"></div>
            <FooterArea />
        </main>
    </div>
</template>

<script>
import MainHeader from '../Layouts/MainHeader'
import PageTitle from '../Common/PageTitle'
import FollowersContent from '../Followers/FollowersContent'
import FooterArea from '../Layouts/FooterArea'

export default {
    name: 'FollowersPage',
    components: {
        MainHeader,
        PageTitle,
        FollowersContent,
        FooterArea,
    },
    mounted () {
        document.body.classList.add('body-bg-f8faff')
    },
}
</script>